import { track } from 'modules/core/lib/Tracking'
import { events } from './events'

type Origin = 'manual' | 'one'
type AttachmentContext = 'detail' | 'create'

// Navigation
export const trackGoToTicketing = () => track(events.goToTicketing)
export const trackGoToTicketingInsights = () => track(events.goToTicketingInsights)
export const trackGoToTicketingSettings = () => track(events.goToTicketingSettings)

// Ticket creation
export const trackOpenCreateTicketDialog = () => track(events.openCreateTicketDialog)
export const trackCreateTicket = (props: {
  priority: string
  has_description: boolean
  has_attachments: boolean
  attachments_count: number
  origin: Origin
  has_ai_enhanced_description: boolean
}) => track(events.createTicket, props)

// Ticket detail & updates
export const trackOpenTicketDetail = (props: {
  status: string
  priority: string
  has_ai_summary: boolean
  has_ai_resolution_proposal: boolean
}) => track(events.openTicketDetail, props)

export const trackUpdateTicketStatus = (props: { previous_status: string; new_status: string }) =>
  track(events.updateTicketStatus, props)

export const trackUpdateTicketPriority = (props: {
  previous_priority: string
  new_priority: string
}) => track(events.updateTicketPriority, props)

export const trackUpdateTicketAssigneeTeam = (props: { is_reassignment: boolean }) =>
  track(events.updateTicketAssigneeTeam, props)
export const trackUpdateTicketAssigneeMember = (props: { is_reassignment: boolean }) =>
  track(events.updateTicketAssigneeMember, props)

// Comments & attachments
export const trackAddTicketComment = (props: { origin: Origin; has_ai_enhancement: boolean }) =>
  track(events.addTicketComment, props)

export const trackAddTicketAttachment = (props: { context: AttachmentContext }) =>
  track(events.addTicketAttachment, props)

export const trackDownloadTicketAttachment = () => track(events.downloadTicketAttachment)

// List interactions
export const trackFilterTickets = (props: { filter_type: string }) =>
  track(events.filterTickets, props)

export const trackSearchTickets = () => track(events.searchTickets)

export const trackSortTickets = (props: { sort_field: string; sort_order: string }) =>
  track(events.sortTickets, props)

// Insights
export const trackChangeInsightsTeamFilter = (props: { team_id: string }) =>
  track(events.changeInsightsTeamFilter, props)

export const trackChangeInsightsPeriodFilter = (props: { period: string }) =>
  track(events.changeInsightsPeriodFilter, props)

// AI features
export const trackUseAiDescriptionEnhancement = (props: { intent: string }) =>
  track(events.useAiDescriptionEnhancement, props)

export const trackUseAiReplyDraft = (props: { intent: string }) =>
  track(events.useAiReplyDraft, props)

export const trackViewAiSummary = () => track(events.viewAiSummary)

export const trackViewAiResolutionProposal = () => track(events.viewAiResolutionProposal)

export const trackGenerateAiSuggestions = () => track(events.generateAiSuggestions)
export const trackRegenerateAiSuggestions = () => track(events.regenerateAiSuggestions)

// Settings
export const trackCreateTicketCategory = (props: {
  priority_mode: string
  sla_mode: string
  assignment_mode: string
  ai_suggestions_mode: string
}) => track(events.createTicketCategory, props)

export const trackUpdateTicketCategory = (props: {
  priority_mode: string
  sla_mode: string
  assignment_mode: string
  ai_suggestions_mode: string
}) => track(events.updateTicketCategory, props)

export const trackDeleteTicketCategory = () => track(events.deleteTicketCategory)

export const trackAssignResolverTeam = () => track(events.assignResolverTeam)

export const trackRemoveResolverTeam = () => track(events.removeResolverTeam)
